const BADGE_COLORS = ['blue', 'purple', 'green', 'cyan'] as const;
export type BadgeColor = (typeof BADGE_COLORS)[number];

export const getThemeBadgeColor = (theme?: string): BadgeColor => {
  if (!theme) return 'blue';
  let hash = 0;
  for (let i = 0; i < theme.length; i++) {
    hash = theme.charCodeAt(i) + ((hash << 5) - hash);
  }
  return BADGE_COLORS[Math.abs(hash) % BADGE_COLORS.length];
};
